import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loading"
}
const _hoisted_2 = {
  key: 1,
  class: "empty"
}
const _hoisted_3 = {
  key: 2,
  class: "activity-list"
}
const _hoisted_4 = { class: "activity-details" }
const _hoisted_5 = { class: "activity-title" }
const _hoisted_6 = { class: "activity-meta" }

interface Request {
  id: string
  student_name?: string
  school: string
  school_name?: string
  grade_level: string
  status: string
}

interface Props {
  recentRequests: Request[]
  loading?: boolean
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ActivityList',
  props: {
    recentRequests: { default: () => [] },
    loading: { type: Boolean, default: false }
  },
  setup(__props: any) {

/* eslint-disable no-undef */


const formatStatus = (status: string) => {
  return status.replace('_', ' ').replace(/\b\w/g, l => l.toUpperCase())
}

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_card_title, null, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode("Recent Activity", -1)
        ]))]),
        _: 1
      }),
      _createVNode(_component_v_card_text, null, {
        default: _withCtx(() => [
          (__props.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, "Loading..."))
            : (__props.recentRequests.length === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_2, " No recent activity "))
              : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.recentRequests, (request) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: request.id,
                      class: "activity-item"
                    }, [
                      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "activity-icon" }, "📋", -1)),
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, _toDisplayString(request.student_name || 'New request'), 1),
                        _createElementVNode("div", _hoisted_6, _toDisplayString(request.school_name || request.school) + " • " + _toDisplayString(request.grade_level), 1)
                      ]),
                      _createElementVNode("div", {
                        class: _normalizeClass(["activity-status", `status-${request.status}`])
                      }, _toDisplayString(formatStatus(request.status)), 3)
                    ]))
                  }), 128))
                ]))
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})